export default "__VITE_ASSET__Byk7Ays1__"